export interface MediaAssetItem {
  id: string;
  title: string;
  url: string;
  type: 'logo' | 'video' | 'banner' | 'portrait' | 'gallery';
  category?: string;
  isLiveBroadcast?: boolean;
  fileSizeBytes?: number;
  uploadedBy?: string;
  updatedAt: string;
}

export interface AppMediaResources {
  customLogoUrl: string | null;
  secondaryLogoUrl: string | null;
  heroBannerUrl: string | null;
  royalPortraitUrl: string | null;
  festivalVideoUrl: string | null;
  festivalVideoTitle: string;
  festivalVideoDescription: string;
  galleryImages: MediaAssetItem[];
  promoVideos: MediaAssetItem[];
  lastUpdatedBy: string;
  lastUpdatedAt: string;
}

const MEDIA_STORAGE_KEY = 'uzairue_app_media_resources_v1';
export const MEDIA_CHANGE_EVENT = 'uzairue_media_resources_updated';

export const DEFAULT_MEDIA_RESOURCES: AppMediaResources = {
  customLogoUrl: null,
  secondaryLogoUrl: null,
  heroBannerUrl: 'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=1200&auto=format&fit=crop&q=80',
  royalPortraitUrl: null,
  festivalVideoUrl: '',
  festivalVideoTitle: 'ERUE Festival 2026 Grand Royal Showcase & Cultural Procession',
  festivalVideoDescription: 'Official broadcast featuring 22 Village Masquerade Troupes, HRH Ogieneni Royal Trumpeters, and Uzairue Youth Age-Grade Initiations.',
  galleryImages: [
    {
      id: 'img-1',
      title: '22 Villages Masquerade Ceremony',
      url: 'https://images.unsplash.com/photo-1533105079780-92b9be482077?w=800&auto=format&fit=crop&q=80',
      type: 'gallery',
      category: 'Culture',
      updatedAt: '2026-08-01T10:00:00Z',
    },
    {
      id: 'img-2',
      title: 'Ogieneni Palace Royal Grandstand',
      url: 'https://images.unsplash.com/photo-1541872703-74c5e44368f9?w=800&auto=format&fit=crop&q=80',
      type: 'gallery',
      category: 'Palace',
      updatedAt: '2026-08-02T12:00:00Z',
    },
    {
      id: 'img-3',
      title: 'Jattu Arena Cultural Dancers',
      url: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800&auto=format&fit=crop&q=80',
      type: 'gallery',
      category: 'Festival',
      updatedAt: '2026-08-03T15:00:00Z',
    },
  ],
  promoVideos: [
    {
      id: 'vid-1',
      title: 'HRH Ogieneni Royal Welcome Broadcast',
      url: '',
      type: 'video',
      isLiveBroadcast: true,
      category: 'Royal Directive',
      updatedAt: '2026-08-10T09:00:00Z',
    },
    {
      id: 'vid-2',
      title: 'ERUE SUV Grand Raffle Draw Preview',
      url: '',
      type: 'video',
      isLiveBroadcast: false,
      category: 'Raffle',
      updatedAt: '2026-08-11T14:30:00Z',
    },
  ],
  lastUpdatedBy: 'Ikpemhi Oshioke (erueuzairue@gmail.com)',
  lastUpdatedAt: new Date().toISOString(),
};

export function getAppMediaResources(): AppMediaResources {
  try {
    const raw = localStorage.getItem(MEDIA_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      return {
        ...DEFAULT_MEDIA_RESOURCES,
        ...parsed,
      };
    }
  } catch (err) {
    console.error('Failed to load media resources:', err);
  }
  return DEFAULT_MEDIA_RESOURCES;
}

export function saveAppMediaResources(media: AppMediaResources): void {
  try {
    localStorage.setItem(MEDIA_STORAGE_KEY, JSON.stringify(media));
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(MEDIA_CHANGE_EVENT, { detail: media }));
    }
  } catch (err) {
    console.error('Failed to save media resources:', err);
  }
}

export function resetMediaResourcesToDefaults(): AppMediaResources {
  saveAppMediaResources(DEFAULT_MEDIA_RESOURCES);
  return DEFAULT_MEDIA_RESOURCES;
}

export function deployMediaAsset(
  key: 'customLogoUrl' | 'secondaryLogoUrl' | 'heroBannerUrl' | 'royalPortraitUrl' | 'festivalVideoUrl',
  url: string | null,
  updatedBy: string = 'Ikpemhi Oshioke'
): AppMediaResources {
  const media = getAppMediaResources();
  (media as any)[key] = url;
  media.lastUpdatedBy = updatedBy;
  media.lastUpdatedAt = new Date().toISOString();
  saveAppMediaResources(media);
  return media;
}
